import { mapState, mapActions } from 'vuex'
import Errors from '@/utils/Errors'

export default {
  name: 'Error',
  data () {
    return {
      defaultTitle: '',
      defaultBody: '',
      defaultLabel: '閉じる'
    }
  },
  computed: {
    ...mapState({
      active: state => state.error.active,
      title: state => state.error.title,
      body: state => state.error.body,
      label: state => state.error.label,
      mode: state => state.error.mode,
      expiredToken: state => state.error.expiredToken,

      // お知らせ配信管理の場合、true
      isBot: state => state.noticeList.isBot,
    }),

    getTitle () {
      switch (this.mode) {
        case Errors.Mode.TokenExpired:
        case Errors.Mode.InvalidAuth:
          return '認証エラー'
        default:
          return this.title || this.defaultTitle
      }
    },
    getBody () {
      switch (this.mode) {
        case Errors.Mode.TokenExpired:
          if (this.isBot) {
            return this.body
          }
          return this.body + '<br>'
            + 'アクセストークンを更新しますか？'
        case Errors.Mode.InvalidAuth:
          if (this.isBot) {
            return this.body
          }
          return this.body + '<br>'
            + 'ログイン画面に移動します。'
        default:
          return this.body || this.defaultBody
      }
    },
    getAcceptLabel () {
      if (this.isBot) {
        return '閉じる'
      }

      switch (this.mode) {
        case Errors.Mode.TokenExpired:
          return '更新'
        case Errors.Mode.InvalidAuth:
          return 'ログインへ'
        default:
          return this.label || this.defaultLabel
      }
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      console.log('active', to)
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      hide: 'error/hide',
      signout: 'auth/signout'
    }),

    /**
     * ダイアログを閉じる
     */
    closeDialog () {
      this.hide()
    },
    /**
     * メッセージを許諾する
     */
    acceptMessage () {
      if (this.isBot) {
        this.hide()
        return
      }

      // トークンの有効期限が切れた場合
      if (this.mode === Errors.Mode.TokenExpired) {
        this.signout()
          .then(() => {
            this.$router.push({
              name: 'Signin'
            })
          })
        return
      }
      
      // ログイン
      if (this.mode === Errors.Mode.InvalidAuth) {
        this.signout()
          .then(() => {
            this.$router.push({
              name: 'Signin'
            })
          })
        return
      }
      
      // this.$emit('childs-event', {
      //   accept: true
      // })

      this.hide()
    }
  }
}